import api from '@/api/api.js'

// CAISSE-VDF-3 : médecin demandeur des lignes d'une facture, retrouvé par uid dans la Clinique (lecture seule)
export default {
    // patient_id : écarte les lignes d'un autre patient quand deux uid se ressemblent (libellé + horodatage)
    parUids(uids, patient_id) {
        const data = { uids: uids }
        if (Number(patient_id) > 0) data.patient_id = Number(patient_id)
        return api.clinique().post('/caisse/medecins-demandeurs', data, { timeout: 20000 }).then(response => response.data)
    }
}
